module.exports = __webpack_public_path__ + "20f91f4096e192286bc5a278a0d4193f.svg";